import gsap from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const gradientTriggers = gsap.utils.toArray(".gradient-trigger");
const gradients = gsap.utils.toArray(".gradient-text");

const images = gsap.utils.toArray(".wp-block-image img");

const sliderItems = document.querySelector(".block-grand_one_slider .items");
const sliderItemsWidth = sliderItems.scrollWidth;
const horizontalScrollLength = sliderItemsWidth - window.innerWidth + 164;

gsap.to(sliderItems, {
  scrollTrigger: {
    trigger: ".block-grand_one_slider",
    pin: true,
    pinSpacing: true,
    start: "top top",
    end: "+=4000",
    scrub: true,
  },
  x: -horizontalScrollLength,
  ease: "none",
});

gradients.forEach((gradient, index) => {
  gsap.to(gradient, {
    scrollTrigger: {
      trigger: gradientTriggers[index],
      start: "top bottom",
      end: "bottom",
      scrub: true,
    },
    backgroundPositionX: "100%",
    duration: 0.5,
    ease: "none",
  });
});

images.forEach((image) => {
  gsap.from(image, {
    scrollTrigger: {
      trigger: image,
      start: "bottom 150%",
      end: "top 50%",
      scrub: true,
    },
    y: 100,
    ease: "none",
  });
});
